import { Component, OnInit, HostListener, Input } from '@angular/core';
import * as d3 from 'd3';
import { AppConfigService } from 'src/app/services/app-config.service';

@Component({
  selector: 'app-multilevel-piechart',
  templateUrl: './multilevel-piechart.component.html',
  styleUrls: ['./multilevel-piechart.component.scss']
})
export class MultilevelPiechartComponent implements OnInit {

  @Input() GraphData: any;
  @Input() categoryId: any;
  envVar: any;
  constructor(private appConfigService: AppConfigService) {
    this.envVar = this.appConfigService.getEnvironment();
  }

  midAngle(d) {
    return d.startAngle + (d.endAngle) / 2;
  }
  endAngleFn(d) {
    return d.value / 100 * Math.PI * 2;
  }
  labelAngle(d) {
    return d.startAngle;
  }
  ngOnInit() {
    //d3.selectAll("svg").remove();
    //this.drawGraph();
  }
  ngAfterViewInit() {
    if (this.categoryId == 0) {
      if (this.GraphData != undefined && this.GraphData != null && this.GraphData.length != 0) {
        this.LoadMLPieChartsDQT('#mlabelpie' + this.categoryId, this.GraphData);
      }
    }
    else {
      this.LoadMLPieCharts('#mlabelpie' + this.categoryId, this.categoryId, this.GraphData);
    }
  }
  LoadMLPieCharts(chartContainer, categoryId, chartdata) {
    d3.select(chartContainer).html("");

    var categoryData = chartdata.filter((d) => d.CategoryId == categoryId);

    if (categoryData == null && categoryData.length == 0) {
      return;
    }
    if (categoryData[0].SeverityData != null && Object.keys(categoryData[0].SeverityData).length > 0) {
      var TCount = 0;
      for (var key in categoryData[0].SeverityData) {
        TCount = TCount + categoryData[0].SeverityData[key];
      }
      this.drawGraph(categoryData[0].SeverityData, TCount);
    }
    else {
      const NoData = [
        [{
          "label": "No Severity/Priority",
          "value": 0,
          "pertvalue": 0
        }]];
      this.drawGraph(NoData, 0);
    }
  }
  LoadMLPieChartsDQT(chartContainer, chartdata) {
    d3.select(chartContainer).html("");
    if (chartdata != null && Object.keys(chartdata[0]).length > 0) {
      // var TCount = 0;
      // for (var key in chartdata) {
      //   TCount = TCount + chartdata[key];
      // }
      this.drawGraph(chartdata[0], 3);
    }
    else {
      const NoData = [
        [{
          "label": "No Severity/Priority",
          "value": 0,
          "pertvalue": 0
        }]];
      this.drawGraph(NoData, 0);
    }
  }
  drawGraph(categoryData, Totalcount) {
    var data = [];
    var count = 0;
    //var count1 = 0;    
    if (this.categoryId == 0) {
      for (var key in categoryData) {
        var data2 = [];
        var x;
        if (key.toLowerCase().includes('blank')) {
          if (this.envVar.instanceType == 'FDS') {
            x = { "label": "No Severity", "value": 0, "pertvalue": 0 }
          }
          else {
            x = { "label": "No Priority", "value": 0, "pertvalue": 0 }
          }
          data2.push(x);
          data.push(data2);
        }
        else {
          x = { "label": key, "value": categoryData[key], "pertvalue": categoryData[key] }
          data2.push(x);
          data.push(data2);
        }
        count++;
      }
    }
    else {
      if (Totalcount != 0) {
        for (var key in categoryData) {
          var data2 = [];
          var x;
          if (key.toLowerCase().includes('blank')) {
            if (this.envVar.instanceType == 'FDS') {
              x = { "label": "No Severity", "value": 0, "pertvalue": 0 }
            }
            else {
              x = { "label": "No Priority", "value": 0, "pertvalue": 0 }
            }
            data2.push(x);
            data.push(data2);
          }
          else {
            x = { "label": key, "value": categoryData[key], "pertvalue": ((categoryData[key] * 100) / Totalcount).toFixed(2) }
            data2.push(x);
            data.push(data2);
          }
          count++;
        }
      }
      else {
        count = 1;
        data = categoryData;
      }
    }

    // const data = [
    //   [{
    //     "label": "Test Failed",
    //     "value": 70
    //   }],
    //   [{
    //     "label": "Test Passed",
    //     "value": 60
    //   }],
    //   [{
    //     "label": "Perf Test",
    //     "value": 90
    //   }],
    //   [{
    //     "label": "Scale Test",
    //     "value": 50
    //   }]
    // ];

    //const container = document.getElementById("donut_container");
    const container = document.getElementById("mlabelpie" + this.categoryId);
    // set the dimensions and margins of the graph
    // const margin = 0;
    // const width = container.offsetWidth - 100;
    // const height = 420 - 2 * margin;
    var margin = { top: 20, right: 5, bottom: 0, left: 5 },
      width = container.clientWidth - margin.left - margin.right,
      //width = 65 - margin.left - margin.right,
      height = 65 - margin.top - margin.bottom;
    var cwidth = 9;
    var cgap = 3

    if (count == 1) {
      cwidth = 13
      cgap = 7;
    }
    else if (count == 2) {
      cwidth = 11;
      cgap = 6;
    }
    else if (count == 3) {
      cwidth = 10;
      cgap = 5;
    }
    else if (count == 4) {
      cwidth = 10;
      cgap = 4;
    }
    else if (count == 5) {
      cwidth = 9;
      cgap = 3;
    }
    var color;
    if (Totalcount == 0)
      color = ["#e0ebeb"];
    else
      color = ["#E370B3", "#6DDBDC", "#267DB3", "#A35CB6", "#ff9966", "#00ff00", '#cc9900'];

    // append the svg object to the div called donut_container'
    const svg = d3.select("#" + "mlabelpie" + this.categoryId)
      .append("svg")
      .classed("resizableSVG", true)
      .attr('xmlns', "http://www.w3.org/2000/svg")
      .attr('viewBox', "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom) + "")
      .attr('preserveAspectRatio', 'xMidYMid meet')
      //.classed("svg-content", true)
      //.attr("width", width + margin.left + margin.right)
      //.attr("height", height + margin.top + margin.bottom)
      .style('overflow', 'visible')
      .style('margin-left', margin.left)
      .style('margin-right', margin.right);


    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
    //let minHeight_Width = Math.min(width, height) - margin;

    const donut_chart = svg.append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / .8 + ")")
      .attr("class", "slices labels lines circles");

    const legendHead = svg.append('g')
      .attr("transform", "translate(" + width / 2 + ",0)")
      .attr("class", "legendgroup");

    // Compute the position of each group on the pie:
    //data = data.reverse();
    const pie = d3.pie()
      .value(d => d.pertvalue)
    //.sort(d => d.pertvalue);
    let that = this;
    data.forEach((item, index) => {

      var backgroundArc = d3.arc()
        .innerRadius(cgap + cwidth * (index + 3))
        .outerRadius(cwidth * (index + 4))
        .startAngle(0)
        .endAngle(Math.PI * 2);

      var mainArc = d3.arc()
        .innerRadius(cgap + cwidth * (index + 3))
        .outerRadius(cwidth * (index + 4))
        .cornerRadius(cwidth / 1.5)
        .startAngle(0)
        .endAngle(d => this.endAngleFn(d));

      var outerArc = d3.arc()
        .innerRadius(cwidth * (index + 1) - 10)
        .outerRadius(cwidth * (index + 1) - 10);

      let charts = donut_chart
        .selectAll('path_' + index)
        .data(pie(item))
        .enter();

      charts.append("path")
        .attr("d", backgroundArc)
        .attr("fill", "#EBEFF4")

      charts.append("path")
        .attr("d", mainArc)
        .attr("fill", color[index])
        .on('mouseover', function (d, i) {
          d3.select(this).transition()
            .duration('50')
            .style('cursor', 'pointer')
            .attr('opacity', '.50')

          var tooltip = d3.select(container).select("svg")
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "tooltip")
            .style("opacity", 1)
          if (d.data.label == "SimilarColumn" || d.data.label == "DuplicateColumn") {
            tooltip.append("rect")
              .attr("width", (d.data.label.length) * 2.5 + 100)
              .attr('height', 20)
              .style('fill', '#FFFFFF')
              .style('pointer-events', 'none')
              .style('stroke', '#296986')
              .style('stroke-width', 2)
              .style('fill-opacity', 0.8);
          }
          else {
            tooltip.append("rect")
              .attr("width", (d.data.label.length) * 2.5 + 160)
              .attr('height', 40)
              .style('fill', '#FFFFFF')
              .style('pointer-events', 'none')
              .style('stroke', '#296986')
              .style('stroke-width', 2)
              .style('fill-opacity', 0.8);
          }

          var textSvg = tooltip.append("text")
            .attr('x', 7)
            .attr('y', 15)
            .style('pointer-events', 'none')
            .style('fill', '#333333')
            .style('font-size', '12px')
            .style('color', '#333333');
          if (that.envVar.instanceType == 'FDS') {
            if (d.data.label == "SimilarColumn" || d.data.label == "DuplicateColumn") {
              textSvg.append("tspan")
                .style('font-size', '11px')
                .style('pointer-events', 'none')
                .style('font-weight', 'bold')
                .text(d.data.label + " - " + d.data.pertvalue + "%")
            }
            else {
              textSvg.append("tspan")
                .style('font-size', '11px')
                .style('pointer-events', 'none')
                .style('font-weight', 'bold')
                .text("Severity: " + d.data.label + " - " + d.data.pertvalue + "%")
            }
          }
          else {
            textSvg.append("tspan")
              .style('font-size', '11px')
              .style('pointer-events', 'none')
              .style('font-weight', 'bold')
              .text("Priority: " + d.data.label + " - " + d.data.pertvalue + "%")
          }
          textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', '#ffffff')
            .html('&#x25cf') //&#9679; //&bull;

          if (d.data.label != "SimilarColumn" && d.data.label != "DuplicateColumn") {
            textSvg.append("tspan")
              .attr('dx', 0)
              .style('pointer-events', 'none')
              .style('font-size', '11px')
              .text('Ticket Count : ')
              .style('font-weight', 'bold')
            textSvg.append("tspan")
              .attr('dx', 0)
              .style('pointer-events', 'none')
              .style('font-weight', 'bold')
              .text(d3.format(',')(parseInt(d.data.value)));
          }
        })
        .on('mouseout', function () {
          d3.select(this).transition()
            .duration('50')
            .attr('opacity', '1')
          d3.select(container).select("svg").select('.tooltip').style('display', 'none');
          d3.select(container).select("svg").select(".tooltip").remove();
        })
      // charts.append('text')
      //   .attr('dy', '.35em')
      //   .html(d => d.data.value + "%")
      //   .attr('transform', d => {
      //     const pos = mainArc.centroid(d);
      //     pos[0] = pos[0] - 10;
      //     return 'translate(' + pos + ')';
      //   })
      //   .attr('text-anchor', d => this.labelAngle(d) < Math.PI ? 'start' : 'end')
      //   .attr('font-family', 'Graphik Black')
      //   .attr('font-size', '10px')
      //   .attr('fill', '#EBEFF4');
      var legendItemSize = 17;
      var circlex = 10;
      var circley = 70;
      var labelx = 10;
      // data = data.reverse();
      var n = data.length > 3 ? data.length / 2 : data.length;
      //var n = data.length;
      //let LegendDiv = charts.append("div")
      var legend = legendHead
        .selectAll('.legend_' + index)
        .data(pie(item))
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', d => {
          var txtLength = d.data.label.length
          return "translate(" + (index % n * (legendItemSize * 6) - 40 * (n * 1.4)) + "," + (Math.floor(index / n) * (height / 2.1) + 75) + ")";
        })
      //.attr('transform', "translate(" + (index % n * (legendItemSize * 6)-40*(n)) + "," + (Math.floor(index / n) * (height / 2.1) + 75) + ")");
      if (this.envVar.instanceType == 'FDS') {
        legend
          .append('circle')
          .attr("cx", circlex)
          .attr('cx', d => {
            let len = d.data.label.length;
            return 30;
          })
          .attr("cy", circley)
          .attr('r', 4)
          .style('fill', (item[0].label != "No Severity") ? color[index] : "#e0ebeb");
      }
      else {
        legend
          .append('circle')
          .attr("cx", circlex)
          .attr('cx', d => {
            let len = d.data.label.length;
            return 30;
          })
          .attr("cy", circley)
          .attr('r', 4)
          .style('fill', (item[0].label != "No Priority") ? color[index] : "#e0ebeb");
      }

      legend
        .append('text')
        .attr('x', d => {
          let len = d.data.label.length;
          return 40;
        })
        .attr('y', circley + 3)
        .html((d: any) => d.data.label.length > 15 ? d.data.label.substring(0, 15) + ".." : d.data.label)
        .attr('font-family', 'Graphik Regular')
        .attr('font-size', '11px')
      //.attr("text-anchor", "middle");
      //LegendDiv.append(legend);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    //d3.selectAll("svg").remove();
    //this.drawGraph();
  }

}
